const carbs = 100;
const fat = 100;
const protein = 100;

const state = () =>
({
  carbs,
  fat,
  protein,
});

const update_carbs = (state, value) =>
{
  state.carbs = value;
};

const update_fat = (state, value) =>
{
  state.fat = value;
};

const update_protein = (state, value) =>
{
  state.protein = value;
};

export default
{
  state,
  mutations:
  {
    update_carbs,
    update_fat,
    update_protein,
  },
};